import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

import useModal from 'app/hooks/useModal'
import useSignInPopupStore from 'app/store/signInPopup.store'

const SignInPopup = dynamic(() => import('~/components/popups/SignInPopup'), {
  ssr: false
})

const SignInPopupContainer: RFC = () => {
  const router = useRouter()
  const { updateStore } = useSignInPopupStore()

  const {
    open: isOpenSingInPopup,
    showModal: showSingInPopup,
    hideModal: hideSingInPopup
  } = useModal()

  useEffect(() => {
    updateStore({
      isOpenPopup: isOpenSingInPopup,
      showPopup: showSingInPopup,
      hidePopup: hideSingInPopup
    })
  }, [isOpenSingInPopup])

  useEffect(() => {
    if (isOpenSingInPopup) {
      hideSingInPopup()
    }
  }, [router.asPath])

  return (
    <>
      {isOpenSingInPopup && (
        <SignInPopup isOpen={isOpenSingInPopup} onClose={hideSingInPopup} />
      )}
    </>
  )
}

export default SignInPopupContainer
